import { render } from "./editConfig.vue?vue&type=template&id=02f6ff89&scoped=true"
import script from "./editConfig.vue?vue&type=script&lang=js"
export * from "./editConfig.vue?vue&type=script&lang=js"

import "./editConfig.vue?vue&type=style&index=0&id=02f6ff89&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f6ff89"]])

export default __exports__